export default __webpack_public_path__ + "static/media/dg_bg.faa223a2.png";